import {
    DrawerSvccCuerpo,
    DrawerSvccPie,
    DrawerSvccSeccion
} from '../../../../components/drawer/DrawerSvcc';
import CamposSvcc from '../../../../components/drawer/CamposSvcc';

/**
 * Secciones de la pestaña "Equipo", por `name` de la configuración de campos.
 * Una sección sin ningún campo presente en la configuración no se dibuja.
 */
const SECCIONES_EQUIPO = [
    { clave: 'identificacion', nombres: ['brand', 'model', 'equipmentType', 'substance'] },
    {
        clave: 'fuente',
        nombres: [
            'characteristics',
            'radiationType',
            'activityCURIE',
            'radioisotopeOfTheSource',
            'sourceType'
        ]
    },
    {
        clave: 'potencia',
        nombres: ['equipmentPowerKVP', 'equipmentPowerMAP', 'equipmentPowerMEV']
    },
    { clave: 'procesamiento', nombres: ['imageProcessing', 'processingMethod'] },
    { clave: 'observaciones', nombres: ['observations'] }
];

const RadiologicalEquipmentForm = ({
    radiologicalEquipmentForm,
    handleSubmit,
    handleCancelClick,
    onlyVisual
}: any) => {
    const { radiologicalEquipmentFieldsConfig, formData, errors, handleChange, translate } =
        radiologicalEquipmentForm;

    const secciones = SECCIONES_EQUIPO.filter(({ nombres }) =>
        radiologicalEquipmentFieldsConfig.some((campo: any) => nombres.includes(campo?.name))
    );

    return (
        <>
            <DrawerSvccCuerpo>
                {secciones.map(({ clave, nombres }) => (
                    <DrawerSvccSeccion
                        key={clave}
                        titulo={translate(`radiologicalEquipmentForm.secciones.${clave}`)}
                    >
                        <CamposSvcc
                            config={radiologicalEquipmentFieldsConfig}
                            nombres={nombres}
                            formData={formData}
                            errors={errors}
                            onChange={handleChange}
                            onlyVisual={onlyVisual}
                        />
                    </DrawerSvccSeccion>
                ))}
            </DrawerSvccCuerpo>
            <DrawerSvccPie
                onCancelar={handleCancelClick}
                onConfirmar={handleSubmit}
                textoCancelar={translate('radiologicalEquipmentForm.buttons.cancel')}
                textoConfirmar={translate('radiologicalEquipmentForm.buttons.next')}
                nota={
                    onlyVisual
                        ? undefined
                        : translate('radiologicalEquipmentForm.notaPaso', { paso: 1 })
                }
                sinConfirmar={onlyVisual}
            />
        </>
    );
};

export default RadiologicalEquipmentForm;
